import type { MetaDataObj } from 'src/helper/shared-types';

type ListingStateType = import('./types').ListingStateType;

export const LISTING_CONTENT_TYPES = {
  ADDRESS: 'address',
  CATEGORY: 'category',
  CURRENCY: 'currency',
  CUSTOM: 'custom',
  DATE_TIME: 'date-time',
  STATUS: 'status',
  TEXT: 'text',
  TIME_ELAPSED: 'time-elapsed',
} as const;

export const LISTING_ICONS = {
  ADDRESS: 'address',
  DATE_TIME: 'date-time',
  TOOL: 'tool',
  DOLLAR: 'dollar',
} as const;

export const LISTING_STATE_KEYS = {
  CURRENT_FILTER_REFERENCE_OBJ: 'currentFilterReferenceObj',
  CURRENT_LISTING_TAB: 'currentListingTab',
  DATA: 'data',
  SOURCE: 'source',
  FILTER_MAPPING: 'filterMapping',
  FILTERS: 'filters',
  FILTERS_COUNT: 'filtersCount',
  IS_FILTERING_LIST: 'isFilteringList',
  IS_FILTER_LOADING: 'isFilterLoading',
  IS_LOADING: 'isLoading',
  META: 'meta',
  SEARCH: 'search',
  SORT_BY: 'sortBy',
  SORT_MAPPING: 'sortMapping',
  TAB_COUNTS: 'tabCounts',
  TABLE_MAPPING: 'tableMapping',
  SHOW_SIDE_PANEL: 'showSidePanel',
  IS_FETCHING_DETAILS: 'isFetchingDetails',
} as const;

export const LISTING_INITIAL_STATE: ListingStateType = {
  currentFilterReferenceObj: {},
  data: [],
  filterMapping: [],
  filters: {},
  filtersCount: 0,
  isFilteringList: false,
  isFilterLoading: true,
  isLoading: false,
  isFetchingDetails: false,
  isFetchingVendorAvailability: false,
  meta: {
    current_page: 0,
    from: 0,
    last: '',
    next: '',
    per_page: 0,
    prev: '',
    to: 0,
    total: 0,
  },
  search: {
    searchInput: '',
    recentSearches: [],
  },
  source: {},
  sortBy: '',
  sortMapping: [],
  tableMapping: [],
};

export const INITIAL_META: MetaDataObj = {
  current_page: 0,
  from: 0,
  last: '',
  next: '',
  per_page: 0,
  prev: '',
  to: 0,
  total: 0,
};

export const BANNER_APPROVED_MESSAGE =
  'You’re all set! Your profile has been approved — you can now start receiving and managing work orders.';
